'use strict';
var parent = require('../../actual/instance/for-each');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/instance/for-each.js
// module id = 621
// module chunks = 13